import React, { useContext, useCallback, useState } from 'react';
import { withRouter } from 'react-router-dom';
import TicketContext from '@nile/mangifera/src/Contexts/TicketContext';
import { Popover } from '@superops/ui-design-system';
import { AccessControl } from '@nile/components';

import { AssociatedAssetParent, AssetActionsPopover } from './styles';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

function AssociatedAsset(props) {
  const { asset } = props;

  const [assetPopover, setAssetPopover] = useState(false);

  const tabContext = useContext(TicketContext);

  const toggleAssetActionsPopover = useCallback(() => {
    setAssetPopover(!assetPopover);
  });

  const assetActionsActivator = (
    <AccessControl
      roleToCheck="itDocumentation.edit"
      render={
        <div
          className="asset-actions-toggle mr-10 ptr"
          onClick={() => toggleAssetActionsPopover()}
        >
          <SVGIcon name="Menu" />
        </div>
      }
    />
  );

  const handleAssociationRemoval = (assetId) => {
    props.removeAssociation([assetId]);
  };

  const navToDetailsPage = () => {
    const { assetId } = asset;
    const { entityName, classId } = props?.assetClass;
    // remove id check once monitored asset is removed from backend in the non monitored associated asset list api
    if (entityName && classId && classId !== '1') {
      tabContext.openTab({
        module: 'NON_MONITORED_ASSET_DETAILS',
        data: {
          entityName,
          classId,
          assetId
        }
      });
    }
  };

  return (
    <AssociatedAssetParent>
      <div className="flex-row asset-block">
        <div
          className="flex-item-balloon asset-name-block"
          onClick={navToDetailsPage}
        >
          {asset.name}
        </div>
        <Popover
          activator={assetActionsActivator}
          active={assetPopover}
          onClose={() => {
            toggleAssetActionsPopover();
          }}
        >
          <AssetActionsPopover>
            <div
              className="action-block"
              onClick={() => {
                handleAssociationRemoval(asset.assetId);
              }}
            >
              <div className="delete-action-name">
                <FormattedMessage id="asset.details.itDoc.removeAssociation" />
              </div>
            </div>
          </AssetActionsPopover>
        </Popover>
      </div>
    </AssociatedAssetParent>
  );
}

export default withRouter(AssociatedAsset);
